import {
  CdkDragDrop,
  DragDropModule,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, input, model, TemplateRef } from '@angular/core';
import { AbbIconComponent } from '@components/abb-icon/abb-icon.component';

@Component({
  selector: 'abb-drag-drop-list',
  standalone: true,
  imports: [CommonModule, DragDropModule, AbbIconComponent],
  template: `
    <div
      class="cdk-drag-list"
      cdkDropList
      (cdkDropListDropped)="onDrop($event)"
    >
      @for (item of list(); track item) {
      <div
        class="cdk-drag-box"
        [ngClass]="{
          'outline outline-1 outline-abb-black/20': list().length === 1
        }"
        cdkDrag
      >
        <div class="cdk-drag-handle" cdkDragHandle>
          <abb-icon
            [name]="'mat/drag_handle'"
            class="text-abb-primary"
          ></abb-icon>
        </div>
        <ng-container
          *ngTemplateOutlet="
            template();
            context: { $implicit: item, index: $index }
          "
        ></ng-container>
      </div>
      }
    </div>
  `,
  styles: `
// TODO: customize to match ABB style as necessary
.cdk-drag-list {
  border: solid 1px rgb(var(--abb-color-black) / 0.2);
  min-height: 60px;
  display: block;
  background: var(--abb-color-background);
  border-radius: 4px;
  overflow: hidden;
}

.cdk-drag-box {
  padding: 0 10px;
  border-bottom: solid 1px rgb(var(--abb-color-black) / 0.2);
  color: var(--abb-color-font);
  display: flex;
  flex-direction: row;
  justify-content: start;
  gap: 1rem;
  box-sizing: border-box;
  background: var(--abb-color-background);
  font-size: 14px;
}

.cdk-drag-handle {
  cursor: move;
  display: flex;
  align-items: center;
}

.cdk-drag-preview {
  border: none;
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 5px 5px -3px rgba(var(--base-value-color-background) / 0.2),
              0 8px 10px 1px rgba(var(--base-value-color-background) / 0.14),
              0 3px 14px 2px rgba(var(--base-value-color-background) / 0.12);
}

.cdk-drag-placeholder {
  opacity: 0;
}

.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.cdk-drag-list.cdk-drop-list-dragging .cdk-drag-box:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}`,
})
export class AbbDragDropListComponent<T> {
  template = input.required<TemplateRef<{ $implicit: T; index: number }>>();

  list = model.required<T[]>();

  onDrop(e: CdkDragDrop<T[]>): void {
    const valueClone = this.list().slice();
    moveItemInArray(valueClone, e.previousIndex, e.currentIndex);
    this.list.set(valueClone);
  }
}
